// extracted by mini-css-extract-plugin
export var closeButton = "_46-3";
export var header = "_46-0";
export var link = "_46-1";
export var retryButton = "_46-2";